import { render, staticRenderFns } from "./Odd.vue?vue&type=template&id=5fa58c72&"
import script from "./Odd.vue?vue&type=script&lang=js&"
export * from "./Odd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports